// eslint-disable-next-line lines-around-comment
import React from 'react';
import Avatar from '../../../base/avatar/components/Avatar';
import StatelessAvatar from '../../../base/avatar/components/web/StatelessAvatar';
import { getInitials } from '../../../base/avatar/functions';
import { IconUser } from '../../../base/icons/svg';
import BaseTheme from '../../../base/ui/components/BaseTheme.web';
import TimeElapsed from './TimeElapsed';
import Timeline from './Timeline';
import { isMobileBrowser } from "../../../base/environment/utils";
const SpeakerStatsItem = (props) => {
    const rowDisplayClass = `row item ${props.hasLeft ? 'has-left' : ''}`;
    const nameTimeClass = `name-time${props.showFaceExpressions ? ' expressions-on' : ''}`;
    const timeClass = `time ${props.isLocalStats ? 'local' : ''}`;
    const isMobile = isMobileBrowser();
    return (React.createElement("div", { key: props.participantId },
        React.createElement("div", { className: rowDisplayClass },
            React.createElement("div", { className: 'avatar' }, props.hasLeft ? (React.createElement(StatelessAvatar, { className: 'userAvatar', color: BaseTheme.palette.ui04, iconUser: IconUser, initials: getInitials(props.displayName), size: isMobile ? 44 : 40 })) : (React.createElement(Avatar, { className: 'userAvatar', participantId: props.participantId, size: isMobile ? 44 : 40 }))),
            React.createElement("div", { className: nameTimeClass },
                React.createElement("div", { style: { display: 'flex', flexDirection: 'column' } },
                    React.createElement("div", { "aria-label": props.t('speakerStats.speakerStats'), className: 'display-name' }, props.displayName),
                    React.createElement("div", { className: 'display-role' }, props.isModerator ? props.t('videothumbnail.moderator') : props.t('videothumbnail.member'))),
                React.createElement("div", { "aria-label": props.t('speakerStats.speakerTime'), className: timeClass },
                    React.createElement(TimeElapsed, { time: props.dominantSpeakerTime }))),
            props.showFaceExpressions
                && React.createElement(Timeline, { faceLandmarks: props.faceLandmarks })),
        !props.isLastItem && (React.createElement("div", { className: 'dividerContainer' },
            React.createElement("div", { className: 'divider' })))));
};
export default SpeakerStatsItem;
